import { Routes, Route, Navigate, useLocation } from "react-router";
import Header from "./SharedModule/components/Header";
import { ProfessionalServicesQuery } from "./../src/BillingModule/pages/ProfessionalServicesQuery";
import { Invoices } from "./../src/BillingModule/pages/Invoices";
import { Invoice } from "./../src/BillingModule/pages/Invoice";
import { BillableItemsResults } from "./../src/BillingModule/pages/BillableItemsResults";
import { InvoiceQuery } from "./../src/BillingModule/pages/InvoiceQuery";
import { InvoiceSearch } from "./../src/BillingModule/pages/InvoiceSearch";
import { RecurringQuery } from "./../src/BillingModule/pages/RecurringQuery";
import { ForbiddenPage } from "./SharedModule/pages/ForbiddenPage";
import { InteractionType } from "@azure/msal-browser";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { Auth } from "./SharedModule/components/Auth";
import { useSelector } from "react-redux";

import {
  selectAuth,
  selectUserRoles,
} from "./SharedModule/redux/reducers/auth.reducer";
import {
  ROUTE_BILLABLE_ITEMS_RESULTS,
  ROUTE_INVOICES_DETAIL,
  ROUTE_INVOICES_LIST,
  ROUTE_INVOICES_SEARCH,
  ROUTE_INVOICES_FILTERS,
  ROUTE_PROFFESSIONAL_SERVICES_QUERY,
  ROUTE_RECURRING_QUERY,
  ROUTE_PRODUCTS_LIST,
  ROUTE_PRODUCT_SPOTLIGHT,
  ROUTE_PRODUCT_SUCCESSCRITERIA,
  ROUTE_PRODUCT_SPOTLIGHT_SUMMARY_REPORT,
  ROUTE_NOT_FOUND_PAGE,
  ROUTE_PRODUCT_SPOTLIGHT_HISTORY,
  ROUTE_FORBIDDEN_PAGE,
  ROUTE_THEHUB_ADMIN,
  ROUTE_DELETE_PRODUCT_PAGE,
  BILLING_MODULE,
  PRODUCTS_MODULE,
  ADMIN_MODULE,
  NO_MODULE,
  ROUTE_LOG_OUT,
  ROUTE_TIMESHEETS,
  TIMES_MODULE,
  ROUTE_QUERY_TIMESHEETS,
  ROUTE_QUERY_RESULTS_TIMESHEETS,
  ROUTE_HOME,
  ROUTE_SAMPLE_REPORT,
  ROUTE_APPROVE_TIME_TIMESHEETS,
  ROUTE_ACCESS_CONTROL_REPORT_BY_USER,
  ROUTE_ACCESS_CONTROL_REPORT_BY_JIRA_PROJECT,
  ROUTE_ACCESS_CONTROL_REPORT_BY_GITLAB_PROJECT,
  ADMIN_ACCESS,
  ROUTE_TIMESHEETS_REPORTS,
  ROUTE_APPROVE_TIME_TIMESHEETS_BY_USER,
  ROUTE_BAMBOO_TIME_OFF_REPORT,
  ROUTE_TIME_CONFIRMATION_REPORT,
  ROUTE_TIME_CONFIRMATION_RESULTS,
  ROUTE_WHO_IS_OUT_REPORT,
  ROUTE_MEAL_BREAK_REPORT,
  ROUTE_CHANGE_TO_HOLIDAYS_REPORT,
  ROUTE_USERS,
  USERS_MODULE,
  ROUTE_USERS_BAMBOO_PROFILE,
  ROUTE_USERS_PROFILE,
  ROUTE_USERS_ROLES,
  ROUTE_CLIENTS,
  ROUTE_CLIENTS_DETAILS,
  ROUTE_CLIENTS_BILLING_INFO,
  ROUTE_CLIENTS_CONTACTS,
  CLIENTS_MODULE,
  ROUTE_CLIENTS_CONTACTS_PROFILE,
  ROUTE_CLIENTS_NEW_CONTACTS,
  ROUTE_CLIENTS_PRICE_EXCEPTIONS,
  ROUTE_CLIENTS_INVOICES,
  USERS_ALL_ROLES,
  CLIENTS_ALL_ROLES,
  ROUTE_CLIENTS_NEW_CLIENT,
  ROUTE_CLIENTS_WORK,
  ROUTE_CLIENTS_REPORTS,
  ROUTE_CLIENTS_RELATIONSHIP_REVIEW,
  ROUTE_CLIENTS_ADVOCACY_SUMMARY_REPORT,
  ROUTE_CLIENTS_ADVOCACY_DETAIL_REPORT,
  ROUTE_CLIENTS_RELATIONSHIP_UPDATES_REPORT,
  ROUTE_CLIENTS_RELATIONSHIP_REVIEW_REPORT,
  ROUTE_CLIENTS_HUBSPOT_INTEGRATION_LOG_REPORT,
  ROUTE_CLIENTS_RELATIONSHIP_REVIEW_TAB,
  ROUTE_CLIENTS_RELATIONSHIP_KEY_CONTACTS,
  ROUTE_CLIENTS_RELATIONSHIP_KEY_CONTACT_DETAILS,
  ROUTE_CLIENTS_RELATIONSHIP_NEW_KEY_CONTACT_DETAILS,
  ROUTE_CLIENTS_RELATIONSHIP_KEY_CONTACTS_CONFIDENCE_HISTORY,
  ROUTE_CLIENTS_EDIT,
  ROUTE_ASSETS,
  ROUTE_ASSETS_MONTHLY_CHARGES_REPORT,
  ROUTE_ASSETS_CHANGES_LOG_REPORT,
  ASSETS_MODULE,
  ASSETS_ALL_ROLES,
  ROUTE_CLIENTS_CHANGEGEAR_INTEGRATION_LOG_REPORT,
} from "./SharedModule/utils/constants";
import { ToastPortal } from "./SharedModule/components/ToastPortal";
import { SpotlightSummaryReportPage } from "./ProductsModule/pages/SpotlightSummaryReport";
import { ProductsListPage } from "./ProductsModule/pages/ProductsListPage";
import { SpotlightPage } from "./ProductsModule/pages/SpotlightPage";
import { SuccessCriteriaPage } from "./ProductsModule/pages/SuccessCriteriaPage";
import { NotFoundPage } from "./SharedModule/pages/NotFoundPage";
import { SpotlightHistoryPage } from "./ProductsModule/pages/SpotlightHistoryPage";
import { AdminPage } from "./SharedModule/pages/AdminPage";
import { DeleteProductPage } from "./ProductsModule/pages/DeleteProductPage";
import { HomePage } from "./SharedModule/pages/HomePage";
import { LeftNavBarProducts } from "./ProductsModule/components/LeftNavBarProducts";
import { LeftNavBarBilling } from "./BillingModule/components/LeftNavBarBilling";
import { LeftNavBarAdmin } from "./SharedModule/components/LeftNavBarAdmin";
import { LogOutPage } from "./SharedModule/pages/LogOutPage";
import { actualUIState } from "./SharedModule/redux/reducers/uiShared.reducer";
import { TimesPage } from "./TimesModule/pages/TimesPage";
import { LeftNavBarTimesheets } from "./TimesModule/components/LeftNavBarTimesheets";
import { TimesQueryPage } from "./TimesModule/pages/TimesQueryPage";
import { QueryResultsPage } from "./TimesModule/pages/QueryResultsPage";
import { MaintenancePage } from "./SharedModule/pages/MaintenancePage";
import { hasAccessDuringMaintenance } from "./SharedModule/utils/maintenanceHelper";
import { SampleReportPage } from "./SharedModule/pages/SampleReportPage";
import { ApproveTimePage } from "./TimesModule/pages/ApproveTimePage";
import { AccessControlReportByUser } from "./SharedModule/pages/AccessControlReportPageByUser";
import { AccessControlReportPageByJiraProject } from "./SharedModule/pages/AccessControlReportPageByJiraProject";
import { AccessControlReportPageByGitlabProject } from "./SharedModule/pages/AccessControlReportPageByGitlabProject";
import { TimesReportsPage } from "./TimesModule/pages/TimesReportsPage";
import { ApproveTimeByUserPage } from "./TimesModule/pages/ApproveTimeByUserPage";
import { BambooTimeOffReportPage } from "./TimesModule/pages/BambooHRTimeOffReportPage";
import { TimesConfirmationReportsPage } from "./TimesModule/pages/TimesConfirmationReportPage";
import { TimesConfirmationResultsPage } from "./TimesModule/pages/TimesConfirmationResultsPage";
import { WhoIsOutReportsPage } from "./TimesModule/pages/WhoIsOutReportPage";
import { MealBreakReportsPage } from "./TimesModule/pages/MealBreakReportPage";
import { ChangesToHolidaysReportPage } from "./TimesModule/pages/ChangesToHolidayReportPage";
import {
  isOnlyRecurringBillingAdminRole,
  verifyModuleAccess,
} from "./SharedModule/utils/accessUtils";
import { UsersListPage } from "./UsersModule/pages/UsersListPage";
import { LeftNavBarUsers } from "./UsersModule/components/LeftNavBarUsers";
import { BambooProfileImportReportPage } from "./UsersModule/pages/BambooProfileImportReportPage";
import { UserProfilePage } from "./UsersModule/pages/UserProfilePage";
import { UserRolesPage } from "./UsersModule/pages/UserRolesPage";
import { ClientsListPage } from "./ClientsModule/pages/ClientsListPage";
import { ClientDetailPage } from "./ClientsModule/pages/ClientDetailPage";
import { ClientBillingInfoPage } from "./ClientsModule/pages/ClientBillingInfoPage";
import { ClientContactsPage } from "./ClientsModule/pages/ClientContactsPage";
import { LeftNavBarClients } from "./ClientsModule/components/LeftNavBarClients";
import { ClientContactsProfilePage } from "./ClientsModule/pages/ClientContactProfilePage";
import { ClientNewContactPage } from "./ClientsModule/pages/ClientNewContactPage";
import { ClientPriceExceptionsPage } from "./ClientsModule/pages/ClientPriceExceptions";
import { ClientInvoicesPage } from "./ClientsModule/pages/ClientInvoicesPage";
import { ClientNewClientPage } from "./ClientsModule/pages/ClientNewClientPage";
import { ClientWorkPage } from "./ClientsModule/pages/ClientWorkPage";
import { ClientReportsPage } from "./ClientsModule/pages/ClientReportsPage";
import { ClientsRelationshipReviewsListPage } from "./ClientsModule/pages/ClientRelationshipReviewsListPage";
import { ClientAdvocacySummaryReportPage } from "./ClientsModule/reportPages/ClientAdvocacySummaryReport";
import { ClientAdvocacyDetailReportPage } from "./ClientsModule/reportPages/ClientAdvocacyDetailReport";
import { ClientRelationshipUpdatesReportPage } from "./ClientsModule/reportPages/ClientRelationshipUpdatesReport";
import { ClientRelationshipReviewReportPage } from "./ClientsModule/reportPages/ClientRelationshipReviewReport";
import { ClientHubspotIntegrationLogReportPage } from "./ClientsModule/reportPages/ClientHubspotIntegrationLogReport";
import { ClientsRelationshipReviewsTabPage } from "./ClientsModule/pages/ClientRelationshipReviewsTabPage";
import { ClientKeyContactListPage } from "./ClientsModule/pages/ClientKeyContactListPage";
import { ClientKeyContactDetailPage } from "./ClientsModule/pages/ClientKeyContactDetailPage";
import { ClientConfidenceHistoryPage } from "./ClientsModule/pages/ClientsConfidenceHistoryPage";
import { ClientEditPage } from "./ClientsModule/pages/ClientEditPage";
import { AssetsListPage } from "./AssetsModule/pages/AssetsListPage";
import { LeftNavBarAsset } from "./AssetsModule/components/LeftNavBarAsset";
import { MonthlyChargesReportPage } from "./AssetsModule/pages/MonthlyChargesReport";
import { ChangesLogReportPage } from "./AssetsModule/pages/ChangesLogReport";

const DataWrapper = ({ children }: any) => {
  return children;
};

function App() {
  const { userRoles, activeUserEmail, userRolesList, rolesLoaded } =
    useSelector(selectUserRoles);
  const isOnlyRecurringBillingAdmin =
    isOnlyRecurringBillingAdminRole(userRoles);
  const auth = useSelector(selectAuth);
  const location = useLocation();
  const { isLeftNavBarFixed } = useSelector(actualUIState);

  let actualModule: string;
  const path = location.pathname.toLowerCase();
  switch (true) {
    case path.startsWith(ROUTE_INVOICES_LIST):
      actualModule = BILLING_MODULE;
      break;
    case path.startsWith(ROUTE_PRODUCTS_LIST):
    case path.startsWith("/access-control-report-"):
      actualModule = PRODUCTS_MODULE;
      break;
    case path.startsWith(ROUTE_THEHUB_ADMIN):
      actualModule = ADMIN_MODULE;
      break;
    case path.startsWith(ROUTE_TIMESHEETS.toLowerCase()):
      actualModule = TIMES_MODULE;
      break;
    case path.startsWith(ROUTE_USERS.toLowerCase()):
      actualModule = USERS_MODULE;
      break;
    case path.startsWith(ROUTE_CLIENTS.toLowerCase()):
      actualModule = CLIENTS_MODULE;
      break;
    case path.startsWith(ROUTE_ASSETS.toLowerCase()):
      actualModule = ASSETS_MODULE;
      break;
    default:
      actualModule = NO_MODULE;
      break;
  }

  return (
    <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
      <ToastPortal autoClose />
      <DataWrapper>
        <Auth>
          {hasAccessDuringMaintenance(activeUserEmail) && <Header />}
          <div className="main-content">
            <div className="d-flex">
              {hasAccessDuringMaintenance(activeUserEmail) &&
                auth.isAuthenticated &&
                rolesLoaded &&
                actualModule === BILLING_MODULE &&
                !isOnlyRecurringBillingAdmin && <LeftNavBarBilling />}
              {hasAccessDuringMaintenance(activeUserEmail) &&
                rolesLoaded &&
                auth.isAuthenticated &&
                actualModule === PRODUCTS_MODULE && <LeftNavBarProducts />}
              {hasAccessDuringMaintenance(activeUserEmail) &&
                rolesLoaded &&
                verifyModuleAccess(true, ADMIN_ACCESS, userRolesList) &&
                auth.isAuthenticated &&
                actualModule === ADMIN_MODULE && <LeftNavBarAdmin />}
              {hasAccessDuringMaintenance(activeUserEmail) &&
                auth.isAuthenticated &&
                actualModule === TIMES_MODULE && <LeftNavBarTimesheets />}
              {hasAccessDuringMaintenance(activeUserEmail) &&
                rolesLoaded &&
                verifyModuleAccess(true, USERS_ALL_ROLES, userRolesList) &&
                auth.isAuthenticated &&
                actualModule === USERS_MODULE && <LeftNavBarUsers />}
              {hasAccessDuringMaintenance(activeUserEmail) &&
                rolesLoaded &&
                verifyModuleAccess(true, CLIENTS_ALL_ROLES, userRolesList) &&
                auth.isAuthenticated &&
                actualModule === CLIENTS_MODULE && <LeftNavBarClients />}
              {hasAccessDuringMaintenance(activeUserEmail) &&
                rolesLoaded &&
                verifyModuleAccess(true, ASSETS_ALL_ROLES, userRolesList) &&
                auth.isAuthenticated &&
                actualModule === ASSETS_MODULE && <LeftNavBarAsset />}
              <div
                className={`detail-page ${isLeftNavBarFixed ? "fixed" : ""}`}
              >
                {!hasAccessDuringMaintenance(activeUserEmail) && (
                  <Routes>
                    {auth.isAuthenticated && (
                      <Route path="*" element={<MaintenancePage />} />
                    )}
                    {!auth.isAuthenticated && (
                      <Route path="*" element={<LogOutPage />} />
                    )}
                  </Routes>
                )}
                {hasAccessDuringMaintenance(activeUserEmail) && (
                  <Routes>
                    {/* Home Page */}
                    {auth.isAuthenticated && (
                      <Route path={ROUTE_HOME} element={<HomePage />} />
                    )}
                    {/* Billing module routes */}
                    <Route path={ROUTE_INVOICES_LIST} element={<Invoices />} />
                    <Route
                      path={ROUTE_PROFFESSIONAL_SERVICES_QUERY}
                      element={<ProfessionalServicesQuery />}
                    />
                    <Route
                      path={ROUTE_RECURRING_QUERY}
                      element={<RecurringQuery />}
                    />
                    <Route
                      path={ROUTE_BILLABLE_ITEMS_RESULTS}
                      element={<BillableItemsResults />}
                    />
                    <Route path={ROUTE_INVOICES_DETAIL} element={<Invoice />} />
                    <Route
                      path={ROUTE_INVOICES_SEARCH}
                      element={<InvoiceSearch />}
                    />
                    <Route
                      path={ROUTE_INVOICES_FILTERS}
                      element={<InvoiceQuery />}
                    />

                    {/* Products module routes */}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_PRODUCTS_LIST}
                        element={<ProductsListPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_PRODUCT_SPOTLIGHT}
                        element={<SpotlightPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_PRODUCT_SPOTLIGHT_HISTORY}
                        element={<SpotlightHistoryPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_PRODUCT_SUCCESSCRITERIA}
                        element={<SuccessCriteriaPage />}
                      />
                    )}
                    {/* Products reports */}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_PRODUCT_SPOTLIGHT_SUMMARY_REPORT}
                        element={<SpotlightSummaryReportPage />}
                      />
                    )}

                    {/* Times module routes */}
                    {auth.isAuthenticated && (
                      <Route path={ROUTE_TIMESHEETS} element={<TimesPage />} />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_TIMESHEETS_REPORTS}
                        element={<TimesReportsPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_BAMBOO_TIME_OFF_REPORT}
                        element={<BambooTimeOffReportPage />}
                      />
                    )}

                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CHANGE_TO_HOLIDAYS_REPORT}
                        element={<ChangesToHolidaysReportPage />}
                      />
                    )}

                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_QUERY_TIMESHEETS}
                        element={<TimesQueryPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_QUERY_RESULTS_TIMESHEETS}
                        element={<QueryResultsPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_APPROVE_TIME_TIMESHEETS}
                        element={<ApproveTimePage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_APPROVE_TIME_TIMESHEETS_BY_USER}
                        element={<ApproveTimeByUserPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_TIME_CONFIRMATION_REPORT}
                        element={<TimesConfirmationReportsPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_TIME_CONFIRMATION_RESULTS}
                        element={<TimesConfirmationResultsPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_WHO_IS_OUT_REPORT}
                        element={<WhoIsOutReportsPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_MEAL_BREAK_REPORT}
                        element={<MealBreakReportsPage />}
                      />
                    )}

                    {/* Users module routes */}
                    {auth.isAuthenticated && (
                      <Route path={ROUTE_USERS} element={<UsersListPage />} />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_USERS_BAMBOO_PROFILE}
                        element={<BambooProfileImportReportPage />}
                      />
                    )}

                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_USERS_PROFILE}
                        element={<UserProfilePage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_USERS_ROLES}
                        element={<UserRolesPage />}
                      />
                    )}
                    {/* Clients module routes */}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS}
                        element={<ClientsListPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS_EDIT}
                        element={<ClientEditPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS_DETAILS}
                        element={<ClientDetailPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS_BILLING_INFO}
                        element={<ClientBillingInfoPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS_CONTACTS}
                        element={<ClientContactsPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS_CONTACTS_PROFILE}
                        element={<ClientContactsProfilePage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS_NEW_CONTACTS}
                        element={<ClientNewContactPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS_PRICE_EXCEPTIONS}
                        element={<ClientPriceExceptionsPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS_INVOICES}
                        element={<ClientInvoicesPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS_RELATIONSHIP_REVIEW_TAB}
                        element={<ClientsRelationshipReviewsTabPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS_RELATIONSHIP_KEY_CONTACTS}
                        element={<ClientKeyContactListPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS_RELATIONSHIP_KEY_CONTACT_DETAILS}
                        element={<ClientKeyContactDetailPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={
                          ROUTE_CLIENTS_RELATIONSHIP_NEW_KEY_CONTACT_DETAILS
                        }
                        element={<ClientKeyContactDetailPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={
                          ROUTE_CLIENTS_RELATIONSHIP_KEY_CONTACTS_CONFIDENCE_HISTORY
                        }
                        element={<ClientConfidenceHistoryPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS_NEW_CLIENT}
                        element={<ClientNewClientPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS_WORK}
                        element={<ClientWorkPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS_REPORTS}
                        element={<ClientReportsPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS_RELATIONSHIP_REVIEW}
                        element={<ClientsRelationshipReviewsListPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS_ADVOCACY_SUMMARY_REPORT}
                        element={<ClientAdvocacySummaryReportPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS_ADVOCACY_DETAIL_REPORT}
                        element={<ClientAdvocacyDetailReportPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS_RELATIONSHIP_UPDATES_REPORT}
                        element={<ClientRelationshipUpdatesReportPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS_RELATIONSHIP_REVIEW_REPORT}
                        element={<ClientRelationshipReviewReportPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_CLIENTS_HUBSPOT_INTEGRATION_LOG_REPORT}
                        element={<ClientHubspotIntegrationLogReportPage />}
                      />
                    )}
                    {/* Asset module routes */}
                    {auth.isAuthenticated && (
                      <Route path={ROUTE_ASSETS} element={<AssetsListPage />} />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_ASSETS_MONTHLY_CHARGES_REPORT}
                        element={<MonthlyChargesReportPage />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_ASSETS_CHANGES_LOG_REPORT}
                        element={<ChangesLogReportPage />}
                      />
                    )}

                    {/* Admin module routes */}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_THEHUB_ADMIN}
                        element={<AdminPage />}
                      />
                    )}
                    {/* Not found page */}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_NOT_FOUND_PAGE}
                        element={<NotFoundPage />}
                      />
                    )}
                    {/* Forbidden page */}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_FORBIDDEN_PAGE}
                        element={<ForbiddenPage />}
                      />
                    )}
                    {/* Delete product page */}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_DELETE_PRODUCT_PAGE}
                        element={<DeleteProductPage />}
                      />
                    )}
                    {/* Access control report pages */}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_ACCESS_CONTROL_REPORT_BY_USER}
                        element={<AccessControlReportByUser />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_ACCESS_CONTROL_REPORT_BY_JIRA_PROJECT}
                        element={<AccessControlReportPageByJiraProject />}
                      />
                    )}
                    {auth.isAuthenticated && (
                      <Route
                        path={ROUTE_ACCESS_CONTROL_REPORT_BY_GITLAB_PROJECT}
                        element={<AccessControlReportPageByGitlabProject />}
                      />
                    )}

                    {/* Data Report report page */}
                    {auth.isAuthenticated &&
                      (activeUserEmail === "aestrada@itx.com" ||
                        activeUserEmail === "nmendez@itx.com") && (
                        <Route
                          path={ROUTE_SAMPLE_REPORT}
                          element={<SampleReportPage />}
                        />
                      )}
                    {/* Log out page */}
                    <Route path={ROUTE_LOG_OUT} element={<LogOutPage />} />
                    {auth.isAuthenticated && (
                      <Route path="*" element={<NotFoundPage />} />
                    )}
                    {!auth.isAuthenticated && (
                      <Route path="*" element={<LogOutPage />} />
                    )}
                  </Routes>
                )}
              </div>
            </div>
          </div>
        </Auth>
      </DataWrapper>
    </MsalAuthenticationTemplate>
  );
}

export default App;
